import { Route, Routes } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"
import './App.css';
import About from './Components/About'
import 'animate.css';
import 'aos/dist/aos.css';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import Contact from './Components/Contact'
import Footer from "./Components/Footer";
import Software_Development from "./Components/Software_Development";
import Web_Development from "./Components/Web_Development";
import Web_Application from "./Components/Web_Application";
import Graphic_Design from "./Components/Graphic_Design";
import Android_Development from "./Components/Android_Development";
import IOS_Development from "./Components/IOS_Development";
import Portfolio from "./Components/Portfolio";
import Services from "./Components/Services";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AiOutlineArrowUp } from 'react-icons/ai';
import Error from "./Components/Error";
import React, { Suspense, lazy } from "react";
import Projects from "./Components/Projects";


// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

function App() {
  // const firebaseConfig = {
  //   apiKey: "AIzaSyCdMn7b-vuOSfkFi7mXG89FOu40XfC0y-I",
  //   authDomain: "muhammad-rizwan-7fc9c.firebaseapp.com",
  //   projectId: "muhammad-rizwan-7fc9c",
  //   storageBucket: "muhammad-rizwan-7fc9c.appspot.com",
  //   messagingSenderId: "606349781502",
  //   appId: "1:606349781502:web:18ef3fe072ee30722c38af",
  //   measurementId: "G-6WRPM9E2PT"
  // };
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [routePath]);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [])
  return (
    <>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="*" element={<Error />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/Services" element={<Services />} />
        <Route exact path="/Contact" element={<Contact />} />
        <Route exact path="/Portfolio" element={<Portfolio />} />
        <Route exact path="/Projects" element={<Projects />} />
        <Route exact path="/Graphic_Design" element={<Graphic_Design />} />
        <Route exact path="/Web_Application" element={<Web_Application />} />
        <Route exact path="/Web_Development" element={<Web_Development />} />
        <Route exact path="/IOS_Development" element={<IOS_Development />} />
        <Route exact path="/Android_Development" element={<Android_Development />} />
        <Route exact path="/Software_Development" element={<Software_Development />} />
      </Routes>
      <Footer />
      <button className="animate__animated animate__backInDown animate__delay-5s animate__slower	3s"
        onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); }}
        style={{ position: 'fixed', padding: '10px', bottom: '0px', right: '0px', backgroundColor: '#0C9', borderRadius: "50px 0px 0px 0px", color: '#fff', textAlign: 'center', }} >
        <AiOutlineArrowUp />
      </button>
    </>
  );
}
export default App;